import { trackUser } from '@api/tracking/client';
import type { TrackingContext } from '@mentimeter/http-clients';
import { core } from '@mentimeter/http-clients';
import { useToast } from '@mentimeter/toast';
import useSWRMutation from 'swr/mutation';

export function useRequestUpgradeMutation({
  trackingContext,
  trackingPlacement,
  onSuccess,
}: {
  trackingContext: TrackingContext | undefined;
  trackingPlacement: string;
  onSuccess?: () => void;
}) {
  const toast = useToast();
  return useSWRMutation(
    useRequestUpgradeMutation.name,
    (_, { arg }: { arg: string }) =>
      core()
        .workspaces.requestUpgrade(arg)
        .then(() => {}),
    {
      onSuccess() {
        trackUser({
          event: 'Request to upgrade sent',
          properties: {
            context: trackingContext,
            placement: trackingPlacement,
          },
        });
        onSuccess?.();
      },
      onError() {
        toast.displayToast({
          variant: 'negative',
          autoDismiss: true,
          description: 'Your request to upgrade role failed. Try again.',
        });
      },
    },
  );
}
